type KeyShouldNotBlank<T extends string> = T extends "" ? never : T;

/**
 * to handle the query param searches
 *
 * @param key  - To access the particular key value
 *
 * @returns instance of search param
 * @author rajkumar rathod
 */
export const useQueryParams = <T extends string>(key: KeyShouldNotBlank<T>) =>
  new URLSearchParams(window.location.search).get(key);

/** @see - `detail explanation` */
/**
 * @Example
 * dummy structure should write while using param
 * const location = useLocation();
 * const queryParams = new URLSearchParams(location.search);
 * queryParams.get('key');
 *
 */
/**
 * @summary reduce above code snippet
 */
